/**
 * `/report-preview` — standalone window for the printable report.
 *
 * Used when an operator wants to preview the print layout in a dedicated
 * browser window (vs. the in-place iframe). Reads the snapshot ID from the
 * URL: `/report-preview?analysis=<id>`.
 */

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ShareAnalysisSnapshot } from '@eloquor/api-contract';
import { readShareAnalysis } from '../api/analyses';
import { ReportMain } from '../report/components/ReportMain';

export function ReportPreviewPage() {
  const [params] = useSearchParams();
  const analysisId = params.get('analysis');
  const [snap, setSnap] = useState<ShareAnalysisSnapshot | null>(null);

  useEffect(() => {
    if (!analysisId) return;
    void readShareAnalysis(analysisId).then(setSnap).catch(() => undefined);
  }, [analysisId]);

  if (!analysisId) return <div style={{ padding: 32 }}>Missing ?analysis= parameter.</div>;
  if (!snap) return <div style={{ padding: 32 }}>Loading…</div>;
  return (
    <div className="report-page">
      <ReportMain cards={snap.cards} summary={snap.summary} />
    </div>
  );
}
